import { render, staticRenderFns } from "./MultilineTextarea.vue?vue&type=template&id=4c836f6c&scoped=true&"
import script from "./MultilineTextarea.vue?vue&type=script&lang=js&"
export * from "./MultilineTextarea.vue?vue&type=script&lang=js&"
import style0 from "./MultilineTextarea.vue?vue&type=style&index=0&id=4c836f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c836f6c",
  null
  
)

export default component.exports